import React, { Fragment, useRef } from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ListPromo from "../../components/promo/List";
import FormCreatePromotion from "../../components/promo/FormCreate";
import { updateModalContent, toggleModal } from "../../actions/modal";

const List = ({ updateModalContent, toggleModal }) => {
    const formCreateRef = useRef();

    const onAddNewPromo = () => {
        updateModalContent({
            title: "Add New Promo",
            content: <FormCreatePromotion ref={formCreateRef} />,
            actionButton: {
                actionText: "Save",
                actionType: "primary",
                action: () => formCreateRef.current.submitForm()
            },
            cancelText: "Cancel",
            closeAfterAction: false,
            className: "wide"
        });

        toggleModal();
    };

    return (
        <Fragment>
            <div className="content-header">
                <h1>Promo</h1>
                <Button variant="contained" onClick={() => onAddNewPromo()}>
                    Add New
                </Button>
            </div>
            <ListPromo />
        </Fragment>
    );
};

List.postTypes = {
    updateModalContent: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired
};

export default connect(null, {
    toggleModal,
    updateModalContent
})(List);
